// extracted by mini-css-extract-plugin
module.exports = {"InformationWidgets":"InformationWidgets-module--InformationWidgets--3IRU3"};